import "react-segmented-choice/styles.css";
import "./styles.css";
import { mountQcSegment, unmountQcSegment } from "./QcSegment.jsx";

/** Bridge: vanilla app.js mounts R13 via this island API. */
window.__aigcQc = {
  mount: mountQcSegment,
  unmount: unmountQcSegment,
};

import "./app.js";
